import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import { flowRight as compose } from 'lodash';

import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import { connect } from 'react-redux';

// Helper
import { getWishListStatus } from '../../helpers/wishListStatus';

// Locale
import messages from '../../locale/jsonMessages';

// Redux Actions
import { openWishListModal } from '../../actions/WishList/modalActions';
import { openLoginModal } from '../../actions/modalActions';

// Image
import heartOff from '/public/SiteIcons/wishlistOff.svg';
import heartOn from '/public/SiteIcons/wishlistOn.svg';

import { withQuery } from '../../hoc/withGraphql';
import { getListingDataQuery } from '../../lib/graphql';

import cs from '../../components/commonStyle.css';
import s from './WishListIcon.css';

const WishListIcon = (props) => {
    const {
        isChecked = false,
        listId,
        type = 'icon',
        heartIcon,
        isAuthenticated,
        wishListModalStatus,
        wishListRoomId,
        openLoginModal,
        openWishListModal,
        isEditWishList
    } = props;

    const [iconSelected, setIconSelected] = useState(isChecked);
    const [clicked, setClicked] = useState(false);

    useEffect(() => {
        setIconSelected(isChecked);
    }, []);

    useEffect(() => {
        const fetchWishListStatus = async () => {
            if (wishListRoomId && wishListModalStatus === false) {
                const currentStatus = await getWishListStatus(listId);
                setIconSelected(currentStatus);
            } else if (!clicked && !wishListModalStatus) {
                setIconSelected(isChecked);
            }
        };
        fetchWishListStatus();
    }, [wishListModalStatus, wishListRoomId, isChecked, listId, clicked]);

    const iconAction = () => {
        if (isAuthenticated) {
            setClicked(true);
            openWishListModal(listId, isEditWishList);
        } else {
            openLoginModal();
        }
    };

    return (
        <>
            {type === 'icon' && (
                <div className={cx(s.iconContainer, heartIcon, 'iconContainerRTL')} onClick={iconAction}>
                    <img src={iconSelected ? heartOn : heartOff} />
                </div>
            )}

            {type === 'button' && (
                <div
                    className={cx(
                        s.displayFlex,
                        s.marginRight,
                        'listTitlemarginLeftRTl',
                        cs.curserPointer,
                        s.minWidth
                    )}
                    onClick={iconAction}
                >
                    <img
                        src={iconSelected ? heartOn : heartOff}
                        className={cx(cs.viewListIcon, 'commonIconSpace')}
                    />
                    <h5 className={cx(cs.commonContentText, cs.fontWeightNormal)}>
                        {iconSelected ? (
                            <FormattedMessage {...messages.saved} />
                        ) : (
                            <FormattedMessage {...messages.save} />
                        )}
                    </h5>
                </div>
            )}
        </>
    );
};

WishListIcon.propTypes = {
    isChecked: PropTypes.bool,
    listId: PropTypes.number,
    type: PropTypes.string,
    isAuthenticated: PropTypes.bool,
    openLoginModal: PropTypes.func,
    openWishListModal: PropTypes.func,
    wishListModalStatus: PropTypes.bool,
    wishListRoomId: PropTypes.number,
    isEditWishList: PropTypes.bool,
    heartIcon: PropTypes.string
};

const mapState = (state) => ({
    isAuthenticated: state.runtime.isAuthenticated,
    wishListModalStatus: state.modalStatus.wishListModalOpen,
    wishListRoomId: state.modalStatus.listId
});

const mapDispatch = {
    openLoginModal,
    openWishListModal
};

export default compose(
    withStyles(cs, s),
    connect(mapState, mapDispatch),
    withQuery(
        getListingDataQuery,
        {
            options: (props) => ({
                variables: {
                    listId: Number(props?.listId)
                },
                fetchPolicy: 'network-only',
                ssr: false
            })
        }
    )
)(WishListIcon);
